import { render } from "./DayPlannerRecipe.vue?vue&type=template&id=228ab765"
import script from "./DayPlannerRecipe.vue?vue&type=script&lang=js"
export * from "./DayPlannerRecipe.vue?vue&type=script&lang=js"

import "./DayPlannerRecipe.vue?vue&type=style&index=0&id=228ab765&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__